import React from 'react';
import { Employee } from '../types';

interface Props {
  employees: Employee[];
  onEdit: (emp: Employee) => void;
  onDelete: (emp: Employee) => void;
  sortField: string;
  sortOrder: string;
  onSort: (field: string) => void;
}

const Table: React.FC<Props> = ({
  employees,
  onEdit,
  onDelete,
  sortField,
  sortOrder,
  onSort
}) => {
  const getArrow = (field: string) => {
    if (sortField !== field) return '↕️';
    return sortOrder === 'asc' ? '⬆️' : '⬇️';
  };

  const getRowClass = (expDate: string) => {
    const days = Math.floor(
      (new Date(expDate).getTime() - new Date().getTime()) / (1000 * 60 * 60 * 24)
    );
    if (days < 30) return 'row-critical';
    if (days < 60) return 'row-warning';
    return '';
  };

  return (
    <div className="table-wrapper">
      <table>
        <thead>
          <tr>
            <th onClick={() => onSort('fullName')}>ФИО {getArrow('fullName')}</th>
            <th onClick={() => onSort('position')}>Должность {getArrow('position')}</th>
            <th onClick={() => onSort('passNumber')}>№ Пропуска {getArrow('passNumber')}</th>
            <th onClick={() => onSort('expirationDate')}>Дата окончания {getArrow('expirationDate')}</th>
            <th>🛠️</th>
          </tr>
        </thead>
        <tbody>
          {employees.map((emp, index) => (
            <tr key={index} className={getRowClass(emp.expirationDate)}>
              <td>{emp.fullName}</td>
              <td>{emp.position}</td>
              <td>{emp.passNumber}</td>
              <td>{new Date(emp.expirationDate).toLocaleDateString('ru-RU')}</td>
              <td>
                <button onClick={() => onEdit(emp)}>✏️</button>
                <button onClick={() => onDelete(emp)} style={{ marginLeft: '8px' }}>🗑️</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>

      {/* Карточки для мобильных */}
      {employees.map((emp, index) => (
        <div key={index} className={`table-card ${getRowClass(emp.expirationDate)}`}>
          <div><strong>ФИО:</strong> {emp.fullName}</div>
          <div><strong>Должность:</strong> {emp.position}</div>
          <div><strong>№ Пропуска:</strong> {emp.passNumber}</div>
          <div><strong>Дата окончания:</strong> {new Date(emp.expirationDate).toLocaleDateString('ru-RU')}</div>
          <div style={{ marginTop: '8px' }}>
            <button onClick={() => onEdit(emp)}>✏️</button>
            <button onClick={() => onDelete(emp)} style={{ marginLeft: '8px' }}>🗑️</button>
          </div>
        </div>
      ))}
    </div>
  );
};

export default Table;
